import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import App from './App.vue'
import router from './router'
import store from './store'
import './styles/base.css'
import './styles/common.scss'
import './styles/element-variables.scss'
import userCache from './utils/userCache'
import common from "./utils/common"


Vue.use(ElementUI)

Vue.config.productionTip = false
Vue.prototype.$userCache = userCache
Vue.prototype.$common = common;

new Vue({
    router,
    store,
    render: (h) => h(App)
}).$mount('#app')
